import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSave, faCloudUploadAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { supabase } from '../lib/supabaseClient';

const ExpenseModal = ({ 
  isOpen, 
  onClose, 
  onSave, 
  expenseToEdit, 
  drivers, 
  loads,

  fromLoads = false,
  loadId,
  driverId
}) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  
  const fetchExpsenseTypes = async () => {
    try {
      const { data, error } = await supabase
        .from('load_expenses_types')
        .select('*')
        .eq('active', true)
        .order('id', { ascending: true });
      if (error) throw error;
      setExpenseTypes(data || []);
    } catch (error) {
      console.error('Hata:', error);
    }
  };

  useEffect(() => {
    fetchExpsenseTypes();
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    try {
      const { data, error } = await supabase.from('countries').select('*');
      if (error) throw error;
      setCountries(data || []);
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };

  const [formData, setFormData] = useState({
    load_id: '',
    driver_id: '',
    expense_type: '',
    amount: '',
    currency_type: 'TRY',
    description: '',
    expense_time: '',
    filepath: '',
    country: '',
    exchange_rate: ''
  });

  useEffect(() => {
    if (isOpen) {
      if (expenseToEdit || (loadId && driverId)) {
        let formattedDate = null;

        if (expenseToEdit?.expense_time) {
        formattedDate = new Date(expenseToEdit.expense_time);

        if (!isNaN(formattedDate.getTime())) {
            formattedDate.setMinutes(
            formattedDate.getMinutes() - formattedDate.getTimezoneOffset()
            );
            formattedDate = formattedDate.toISOString().slice(0, 16);}
        }

        setFormData({
          load_id: expenseToEdit?.load_id || loadId || '',
          driver_id: expenseToEdit?.driver_id || driverId || '',
          expense_type: expenseToEdit?.expense_type?.toString() || '',
          amount: expenseToEdit?.amount?.toString() || '',
          currency_type: expenseToEdit?.currency_type || 'TRY',
          description: expenseToEdit?.description || '',
          expense_time: formattedDate,
          filepath: expenseToEdit?.filepath || '',
          country: expenseToEdit?.country?.toString() || '',
          exchange_rate: expenseToEdit?.exchange_rate?.toString() || ''
        });
      } else {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());

        setFormData({
          load_id: '',
          driver_id: '',
          expense_type: '',
          amount: '',
          currency_type: 'TRY',
          description: '',
          expense_time: now.toISOString().slice(0, 16),
          filepath: '',
          country: '',
          exchange_rate: ''
        });
      }
      setFile(null);
    }
  }, [isOpen, expenseToEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const uploadFile = async () => {
    if (!file) return formData.filepath;

    const fileExt = file.name.split('.').pop();
    const fileName = `expense_${Date.now()}.${fileExt}`;
    const filePath = `documents/${fileName}`;

    const { data, error } = await supabase.storage
      .from('documents') 
      .upload(filePath, file);

    if (error) throw error;

    const { data: { publicUrl } } = supabase.storage
      .from('documents')
      .getPublicUrl(filePath);

    return publicUrl;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        const requiredFields = {
            load_id: 'Yük',
            driver_id: 'Sürücü',
            amount: 'Tutar',
            expense_type: 'Gider tipi',
            currency_type: 'Para birimi',
            expense_time: 'Tarih / Saat'
        };

        for (const key in requiredFields) {
            if (!formData[key]) {
            alert(`Lütfen "${requiredFields[key]}" alanını doldurun.`);
            return;
            }
        }

        let finalFilePath = formData.filepath;
        if (file) {
            finalFilePath = await uploadFile();
        }

        const payload = {
            load_id: formData.load_id,
            driver_id: formData.driver_id,
            expense_type: parseInt(formData.expense_type),
            amount: parseFloat(formData.amount),
            currency_type: formData.currency_type,
            description: formData.description,
            expense_time: formData.expense_time,
            filepath: finalFilePath,
            country: formData.country ? parseInt(formData.country) : null,
            exchange_rate: formData.exchange_rate ? parseFloat(formData.exchange_rate) : null
        };

      let error;
      if (expenseToEdit) {
        const { error: updateError } = await supabase
          .from('load_expenses')
          .update(payload)
          .eq('id', expenseToEdit.id);
        error = updateError;
      } else {
        const { error: insertError } = await supabase
          .from('load_expenses')
          .insert([payload]);
        error = insertError;
      }

      if (error) throw error;

      onSave();
      onClose();

    } catch (err) {
      console.error('Kayıt hatası:', err);
      alert('Kaydederken bir hata oluştu: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 bg-gray-50 rounded-t-xl">
          <h3 className="text-lg font-bold text-gray-800">
            {expenseToEdit ? 'Masrafı Düzenle' : 'Yeni Masraf Ekle'}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition">
            <FontAwesomeIcon icon={faTimes} className="text-xl" />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {!fromLoads && (
              <>
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">Sürücü</label>
                  <select
                    name="driver_id"
                    contentEditable={false}
                    disabled={!!expenseToEdit}
                    value={formData.driver_id}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm bg-white"
                    required
                  >
                    <option value="">Seçiniz...</option>
                    {drivers.map(d => (
                      <option key={d.id} value={d.id}>
                        {d.first_name} {d.last_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">İlgili Yük</label>
                  <select
                    name="load_id"
                    disabled={!!expenseToEdit}
                    value={formData.load_id}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm bg-white"
                  >
                    <option value="">Seçiniz...</option>
                    {loads.map(l => (
                      <option key={l.id} value={l.id}>{l?.formatted_id} {l?.reference_number ? ' - ' + l.reference_number : ''}</option>
                    ))}
                  </select>
                </div>
              </>
            )}

            {/* Masraf Tipi */}
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Masraf Tipi</label>
              <select
                name="expense_type"
                value={formData.expense_type}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm bg-white"
                required
              >
                <option value="">Seçiniz...</option>
                {expenseTypes.map(t => (
                  <option key={t.id} value={t.id}>{t.name_tr}</option>
                ))}
              </select>
            </div>

            {/* Tarih */}
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Tarih ve Saat</label>
              <input
                type="datetime-local"
                name="expense_time"
                value={formData.expense_time}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
             {/* Miktar */}
             <div className="col-span-2">
              <label className="block text-xs font-medium text-gray-500 mb-1">Tutar</label>
              <input
                type="number"
                step="0.01"
                name="amount"
                value={formData.amount}
                onChange={handleInputChange}
                placeholder="0.00"
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                required
              />
            </div>
            {/* Para Birimi */}
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Para Birimi</label>
              <select
                name="currency_type"
                value={formData.currency_type}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm bg-white"
              >
                <option value="TRY">TRY</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="RUB">RUB</option>
                <option value="AZN">AZN</option>
                <option value="GEL">GEL</option>
                <option value="AMD">AMD</option>
                <option value="Other">Diğer</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {/* Ülke */}
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Ülke</label>
              <select
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm bg-white"
              >
                <option value="">Seçiniz...</option>
                {countries.map(c => (
                  <option key={c.id} value={c.id}>{c.name_tr}</option>
                ))}
              </select>
            </div>

            {/* Döviz Kuru */}
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Döviz Kuru</label>
              <input
                type="number"
                step="0.01"
                name="exchange_rate"
                value={formData.exchange_rate}
                onChange={handleInputChange}
                placeholder="0.00"
                disabled={formData.currency_type === 'TRY'}
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>
          </div>

          {/* Açıklama */}
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Açıklama</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows="3"
              placeholder="Fiş detayları..."
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
            ></textarea>
          </div>

          {/* Dosya Yükleme */}
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50 text-center relative hover:bg-gray-100 transition">
            <input
              type="file"
              onChange={handleFileChange}
              accept="image/*,.pdf"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            />
            <div className="text-gray-500">
              <FontAwesomeIcon icon={faCloudUploadAlt} className="text-2xl mb-2 text-blue-400" />
              <p className="text-sm font-medium">
                {file ? file.name : 'Belge yüklemek için tıklayın veya sürükleyin'}
              </p>
              {formData.filepath && !file && (
                <p className="text-xs text-green-600 mt-1">Mevcut dosya kayıtlı.</p>
              )}
            </div>
          </div>

          {/* Footer Actions */}
          <div className="flex justify-end space-x-3 pt-4 border-t border-gray-100 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 text-sm transition font-medium"
            >
              İptal
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm transition font-medium flex items-center shadow-lg shadow-blue-200"
            >
              {loading ? <FontAwesomeIcon icon={faSpinner} spin className="mr-2" /> : <FontAwesomeIcon icon={faSave} className="mr-2" />}
              {expenseToEdit ? 'Değişiklikleri Kaydet' : 'Masrafı Oluştur'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExpenseModal;